import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";
import { Reveal, ASSETS } from "@/lib/motion";

const LOCATIONS = [
  { name: "Ayodhya", region: "Uttar Pradesh", status: "Live", img: ASSETS.ayodhyaHero, to: "/ayodhya",
    note: "Where faith, infrastructure and opportunity are converging for the first time in generations." },
  { name: "Dholera", region: "Gujarat", status: "Live", img: ASSETS.ayodhyaInfra,
    note: "A greenfield industrial and smart-city corridor we are actively tracking and sourcing in." },
  { name: "Sohna", region: "Haryana", status: "Live", img: ASSETS.success,
    note: "An emerging extension of the Delhi-NCR growth belt we are actively tracking and sourcing in." },
];

export default function WhereWeOperate() {
  return (
    <section id="opportunities" className="bg-brand-offwhite py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <span className="text-brand-orange text-sm font-semibold tracking-[0.2em] uppercase">Opportunities</span>
          <h2 className="mt-4 font-display font-semibold text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-brand-ink leading-[1.05] max-w-2xl">Where we operate.</h2>
          <p className="mt-6 text-lg text-brand-grey leading-relaxed max-w-2xl">We acquire land across India. These are a glimpse of what we are tracking right now, not the limit of where we look.</p>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-6 mt-14">
          {LOCATIONS.map((l, i) => {
            const hasPage = Boolean(l.to);
            const cls = `group block h-full bg-brand-card border border-brand-ink/10 rounded-sm overflow-hidden transition-colors duration-500 ${hasPage ? "hover:border-brand-orange" : "cursor-default"}`;
            const inner = (
              <>
                <div className="relative h-52 overflow-hidden">
                  <img src={l.img} alt={`${l.name}, ${l.region}`} loading="lazy"
                    className={`w-full h-full object-cover transition-transform duration-700 ${hasPage ? "group-hover:scale-105" : ""}`} />
                  <div className="absolute inset-0 bg-brand-dark/25" />
                  <span className="absolute top-4 right-4 text-[11px] font-semibold uppercase tracking-wide px-3 py-1 rounded-full bg-brand-orange text-white">{l.status}</span>
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-2 text-brand-grey text-xs uppercase tracking-wide mb-2">
                    <MapPin className="w-3.5 h-3.5" /> {l.region}
                  </div>
                  <h3 className="font-display font-semibold text-2xl tracking-tight text-brand-ink">{l.name}</h3>
                  <p className="mt-3 text-brand-grey leading-relaxed text-[15px]">{l.note}</p>
                  {hasPage && (
                    <span className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-brand-ink group-hover:text-brand-orange transition-colors">
                      Explore {l.name} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                    </span>
                  )}
                </div>
              </>
            );
            return (
              <Reveal key={l.name} delay={i * 0.1}>
                {hasPage ? (
                  <Link to={l.to} data-testid={`location-card-${l.name.toLowerCase()}`} className={cls} aria-label={`Explore ${l.name}, ${l.region}`}>
                    {inner}
                  </Link>
                ) : (
                  <div data-testid={`location-card-${l.name.toLowerCase()}`} className={cls}>
                    {inner}
                  </div>
                )}
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
